import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import { tipoInversion, formatToTwoDecimals, formatearNumeroConComas } from '../../services/funcionesPublicas'

import { SERVER_ } from '../../config'


const ModalCargarContrato = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, inversion } = params


 const [ f17, setF17 ] = useState<any>(inversion.monto_inversion)


     let filas = Array.from({ length: inversion.plazo_contrato }, (_, index) => index)

     let X : any = []
     let index = 0
     for(let reg of filas){
         let r : any = {}
         if(index === 0) r = { saldo_inicial : inversion.monto_inversion, cargos :  (inversion.monto_inversion * ( inversion.tasa_incremento / 100 )), saldo_final : (inversion.monto_inversion + ( (inversion.monto_inversion * ( inversion.tasa_incremento / 100 )) ) + 0 )    }
          else{ 
            r = { saldo_inicial : X[index-1].saldo_final, cargos :  ((X[index-1].saldo_final * ( inversion.tasa_incremento / 100 ))), saldo_final : (X[index-1].saldo_final + ( (X[index-1].saldo_final * ( inversion.tasa_incremento / 100 )) ) + 0 )    }
          }
       X.push(r)
       index++
     }
 const [ tabla_final, setTablaFinal ] = useState<any>(X)





  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Carga de Contrato</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            JSON.stringify(inversion.contrato)
          }333

            <h4>Información de Cliente</h4>
            <table className="table table-sm">
              <tbody>
                <tr>
                  <th className="v" style={{width:'40%'}}>Nombre</th>
                  <td>
                    <b>{inversion.nombres}</b>
                    <p className="nm"><small>{`${inversion.paterno} ${inversion.materno}`}</small></p>
                    </td>
                </tr>
                <tr>
                  <th className="v">Fecha de Nacimiento</th>
                  <td>{inversion.fecha_nacimiento}</td>
                </tr>
                <tr>
                  <th className="v">Sexo</th>
                  <td>{inversion.sexo==='H'?'HOMBRE':'MUJER'}</td>
                </tr>
                <tr>
                  <th className="v">CURP</th>
                  <td>{inversion.curp}</td>
                </tr>
                <tr>
                  <th className="v">RFC</th>
                  <td>{inversion.rfc||''}</td>
                </tr>
                <tr>
                  <th className="v">Seguro Social</th>
                  <td>{inversion.seguro_social}</td>
                </tr>
              </tbody>
            </table>

              <h4>Información de Inversión</h4>

              <table className="table table-sm">
                <tbody>
                  <tr>
                    <th className="v" style={{width:'40%'}}>Folio</th>
                    <td>{(inversion.folio)}</td>
                  </tr>
                  <tr>
                    <th className="v" style={{width:'40%'}}>Inversión</th>
                    <td>$ {formatToTwoDecimals(inversion.monto_inversion)}</td>
                  </tr>
                  <tr>
                    <th className="v">Tasa de Incremento</th>
                    <td>{inversion.tasa_incremento} %</td>
                  </tr>
                  <tr>
                    <th className="v">Plazo Contrato</th>
                    <td>{inversion.plazo_contrato} Meses</td>
                  </tr>
                  <tr>
                    <th className="v">Tipo de Retiro</th>
                    <td>{tipoInversion(inversion.tipo_retiro)}</td>
                  </tr>
                  <tr>
                    <th className="v">Forma de Pago</th>
                    <td>{inversion.forma_pago}</td>
                  </tr>
                                {
                                  inversion.tipo_retiro === 'mensual' && (
                                      <React.Fragment>

                                          <tr>
                                            <th className="v">Rendimiento Ganado</th>
                                            <td>
                                                  $ {
                                                    formatearNumeroConComas(
                                                      (Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0)
                                                      )
                                                  }
                                                  {' '}
                                                  <small>({
                                                    formatearNumeroConComas(((Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0) / inversion.monto_inversion ) * 100)
                                                  } %)</small>
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="v">Retención de ISR</th>
                                            <td>
                                                $ {
                                                  formatearNumeroConComas((Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0) * .20)
                                                }
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="v">Neto a Recibir</th>
                                            <td>
                                                  $ {
                                                      formatearNumeroConComas(
                                                        (Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0)
                                                        -
                                                        ((Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0) * .20)
                                                      )
                                                    }
                                            </td>
                                          </tr>



                                      </React.Fragment>
                                    )
                                }




                                {
                                  inversion.tipo_retiro === 'finalizando' && (
                                      <React.Fragment>

                                          <tr>
                                            <th className="v">Rendimiento Ganado</th>
                                            <td>
                                              $ {
                                                formatearNumeroConComas(tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0))
                                              }
                                              {' '}
                                              <small>({
                                                formatearNumeroConComas( (tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)) / inversion.monto_inversion * 100)
                                              } %)</small>
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="v">Retención de ISR</th>
                                            <td>
                                                $ {
                                                  formatearNumeroConComas( (tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)) * .20 )
                                                }
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="v">Neto a Recibir</th>
                                            <td>
                                                $ {
                                                formatearNumeroConComas(
                                                  tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)
                                                  -
                                                  ((tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)) * .20)
                                                  )
                                              }
                                            </td>
                                          </tr>



                                      </React.Fragment>
                                    )
                                }

              </tbody>
            </table>


            <p>
              <a target="_blank" href={`${SERVER_}inversion/contrato/${inversion.uuid_inversion}`} className="btn btn-link btn-sm">Imprimir Contrato <i className="fa fa-file-pdf-o"/></a>
            </p>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" type="button">Ok</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalCargarContrato;